/**
 * @fileoverview GET handler for the "/data_objects/data_object_type_relationships" endpoint.
 * Returns the custom object→custom object relationship types for a given custom object type.
 */
import fetch from "@lib/fetch";

import { buildCustomObjectsQueryParams } from "../customObjectsShared/buildQueryParams";
import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { customObjectsCustomObjectTypeRelationships } from "./constants";
import type {
  GetCustomObjectsCustomObjectTypeRelationshipsParams,
  GetCustomObjectsCustomObjectTypeRelationshipsResult,
} from "./types";
import { isGetCustomObjectsCustomObjectTypeRelationshipsResult } from "./validators";

export const getCustomObjectsCustomObjectTypeRelationships = reactQueryFetcherAdapter(
  customObjectsCustomObjectTypeRelationships,
  (
    signal: AbortSignal,
    params: GetCustomObjectsCustomObjectTypeRelationshipsParams
  ): Promise<GetCustomObjectsCustomObjectTypeRelationshipsResult> => {
    return fetch(
      "/data_objects/data_object_type_relationships",
      "GET",
      buildCustomObjectsQueryParams(params),
      { signal },
      { propagateFetchRequestError: false }
    );
  },
  isGetCustomObjectsCustomObjectTypeRelationshipsResult
);
